export const appendHubspotSnippet = () => {
  const scriptId = 'hs-script-loader'

  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script')

    script.id = scriptId
    script.async = true
    script.defer = true
    script.src = '//js.hs-scripts.com/21051809.js'

    document.documentElement.appendChild(script)
  }
}
